import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import S3 from 'react-aws-s3';
import { createNotification, handleClickCopy } from '../../Resources/helpers/helpFunctions';
import { Button } from '@mui/material';
import { useResourceContext } from 'react-admin';
import bucketUploaderImagenes from '../../Resources/helpers/bucketUploaderImagenes';

window.Buffer = window.Buffer || require('buffer').Buffer;

function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {type:mime});
}

const ButtonAws = ({ setUrl, text, small, variant, style, fileUpload, fileNameCustom, finish, accept, succesText, failedText, disabled}) => {
  const [loading, setLoading] = useState(false);
  const resource = useResourceContext();

  const uploadAWS = async (file, fileName) => {

    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    setLoading(true);
    const response = await bucketUploaderImagenes(formData);

    if (response?.ok) {
      const result = await response.json();
      const url = result?.url;
      setUrl && setUrl(url);
      finish && finish(url);
      createNotification(
        'success',
        succesText ? succesText : 'Imagen subida con exito'
      );
    } else {
      createNotification(
        'error',
        failedText ? failedText : 'No se pudo subir la imagen',
      );
    }
    setLoading(false);
  };
  
  const handleClick = (e) => {
    if(fileUpload){
      setLoading(true);
      const file = dataURLtoFile(fileUpload, fileNameCustom);
      console.log('elprimero',fileUpload);
      if(file.size < 4000000){
        uploadAWS(file, fileNameCustom);
      }else{
        createNotification('error', 'La imagen debe tener 4mb como máximo');
      }
    }
    else if (e.target.files.length > 0) {
      setLoading(true);
      let file = e.target.files[0];
      let fileName = e.target.files[0].name;
      console.log('elprimero',file);
      if(file.size < 4000000){
        uploadAWS(file, fileName);
      }else{
        createNotification('error', 'La imagen debe tener 4mb como máximo');
        setLoading(false);

      }
    }
  };
  return (
    <label style={{width: '100%'}}>
      {
        !fileUpload && (
          <Box style={{display: 'none'}}>
            <input type='file' onChange={handleClick} accept={accept} />
          </Box>
        )
      }
      <Button 
        variant={variant ? variant : 'contained'}
        color='primary' 
        component="span" 
        disabled={loading || disabled}
        size={small && 'small'}
        endIcon={loading && <CircularProgress size='20px' />}
        style={style} 
        onClick={fileUpload && (() => handleClick())}
      >
        <span style={{width: '100%', textAlign: 'center'}}>{text}</span>
      </Button>
    </label>
  );
};

export default ButtonAws;
